import React from 'react';
import styled from 'astroturf/react';

import DownloadIcon from 'js/design_system/icons/arrow_downward.svg';
import BookmarkIcon from 'js/design_system/icons/bookmark_outline.svg';
import BookmarkedIcon from 'js/design_system/icons/bookmark.svg';
import { Button } from 'js/design_system/Button';
import { Props as ImpressionProps } from 'js/utils/impressions/ImpressionWatcher';
import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';

const ButtonRow = styled.div`
  display: flex;
  padding: 16px 0px 24px 0px;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-xs-16, 16px);
  z-index: 10;

  border-top: 1px solid var(--stroke-light, #dddde2);
  background: var(--background-white, #fff);
  box-shadow: 0px -2px 4px 0px rgba(34, 34, 51, 0.25);

  @import 'stylesheets/design_system/_breakpoint.scss';

  @include breakpoint(small) {
    :global(.ds2-5-button) {
      padding: 0 var(--buttons-small-buttons-l-r-padding, 12px);
      height: var(--buttons-small-buttons-height, 44px);
      gap: var(--buttons-small-buttons-gap, 8px);

      border-radius: var(--buttons-small-buttons-corner-radius, 8px);
    }
  }
`;

type Props = {
  impressionProps?: ImpressionProps;
  onDownload?: () => void;
  bookmarked: boolean;
  onBookmark: () => void;
  onUnbookmark: () => void;
  source?: string;
};

const ReaderButtonRow = ({
  impressionProps,
  onDownload,
  bookmarked,
  onBookmark,
  onUnbookmark,
  source,
}: Props) => (
  <ButtonRow>
    <ImpressionWatcher {...impressionProps} source={`${source}_download`}>
      {bookmarked ? (
        <Button icon={<BookmarkedIcon />} onClick={onUnbookmark}>
          Saved to library
        </Button>
      ) : (
        <Button icon={<BookmarkIcon />} onClick={onBookmark}>
          Save to library
        </Button>
      )}
    </ImpressionWatcher>
    <ImpressionWatcher {...impressionProps} source={`${source}_download`}>
      <Button icon={<DownloadIcon />} secondary onClick={onDownload}>
        Download
      </Button>
    </ImpressionWatcher>
  </ButtonRow>
);

export default ReaderButtonRow;
